var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('section', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', [_c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Judul",
      "label-for": "Judul"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "Judul"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "4"
    }
  }, [_c('b-form-group', [_c('label', {
    attrs: {
      "for": "Pilih Paket"
    }
  }, [_vm._v("Pilih Kategori Paket")]), _c('small', {
    staticClass: "text-danger"
  }, [_c('b', [_vm._v(" (*)")])]), _c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.optpaket_id,
      "reduce": function reduce(option) {
        return option.value;
      }
    },
    model: {
      value: _vm.form.category_paket_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "category_paket_id", $$v);
      },
      expression: "form.category_paket_id"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Waktu (Detik)",
      "label-for": "timer_second"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "timer_second"
    },
    model: {
      value: _vm.form.timer_second,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "timer_second", $$v);
      },
      expression: "form.timer_second"
    }
  })], 1)], 1), _vm.type == 'pauli' ? _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tambah Opsi Soal",
      "label-for": "opsi"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.formopsi,
      callback: function callback($$v) {
        _vm.formopsi = $$v;
      },
      expression: "formopsi"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "--",
      "label-for": "opsi"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addOpsi();
      }
    }
  }, [_vm._v("Tambah Opsi")])], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "3"
    }
  }, [_c('b-form-group', [_c('label', {
    staticClass: "text-primary",
    attrs: {
      "for": "total-bobot"
    }
  }, [_c('strong', [_c('i', [_vm._v("Total Bobot Kolom")])])]), _c('b-form-input', {
    attrs: {
      "value": _vm.totalBobotSoal,
      "disabled": ""
    }
  })], 1)], 1)], 1)], 1), _vm.type == 'pauli' ? _c('div', _vm._l(_vm.form.sub_soals, function (data, index) {
    return _c('b-row', {
      key: data.id
    }, [_c('b-col', {
      attrs: {
        "sm": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('b-form-group', [_c('label', {
      attrs: {
        "for": 'h-baris-' + (index + 1)
      }
    }, [_c('strong', [_c('i', [_vm._v(_vm._s("Soal Baris " + (index + 1)))])])]), _c('b-form-input', {
      attrs: {
        "id": 'h-baris-' + data.id,
        "placeholder": "Ex: 1 + 2"
      },
      model: {
        value: data.content,
        callback: function callback($$v) {
          _vm.$set(data, "content", $$v);
        },
        expression: "data.content"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "sm": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": 'Jawaban (Ganjil: 1, Genap: 0)',
        "label-for": 'h-baris-' + (index + 1)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": 'h-baris-' + data.id,
        "placeholder": "Isi 0 atau 1"
      },
      model: {
        value: data.secret_key,
        callback: function callback($$v) {
          _vm.$set(data, "secret_key", $$v);
        },
        expression: "data.secret_key"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "sm": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": 'Bobot Soal',
        "label-for": 'bobot-baris-' + (index + 1)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": 'bobot-baris-' + data.id,
        "placeholder": "Ex: 10"
      },
      model: {
        value: data.bobot,
        callback: function callback($$v) {
          _vm.$set(data, "bobot", $$v);
        },
        expression: "data.bobot"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "sm": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": 'Aksi Baris ' + (index + 1),
        "label-for": 'h-baris-' + (index + 1)
      }
    }, [data.id == null ? _c('b-button', {
      staticClass: "mr-1",
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function click($event) {
          return _vm.TambahSub(data);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "SaveIcon"
      }
    })], 1) : _vm._e(), data.id != null ? _c('b-button', {
      staticClass: "mr-1",
      attrs: {
        "variant": "info"
      },
      on: {
        "click": function click($event) {
          return _vm.EditSub(data);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "SaveIcon"
      }
    })], 1) : _vm._e(), data.id != null ? _c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteOpsi(data);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "TrashIcon"
      }
    })], 1) : _vm._e(), data.id == null ? _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteOpsi(data, true);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "MinusCircleIcon"
      }
    })], 1) : _vm._e()], 1)], 1)], 1);
  }), 1) : _vm._e(), _c('b-button', {
    staticClass: "w-full mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" Simpan ")])], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }